import FabricColor from 'assets/images/img/colors/fabric-color.png'
import PolishColor from 'assets/images/img/colors/polish-color.png'


export const CoatingColor = {
    POLISH_COLOR: 1,
    FABRIC_COLOR: 4
}

const ColorMaterial = {
    [CoatingColor.POLISH_COLOR]: {
        items: [
            {
                id: 1,
                name: 'beige',
                url: `url(${PolishColor}) -10px -10px`,
                hexaDecimal: 'e2d6b0'
            },
            {
                id: 8,
                name: 'white',
                url: `url(${PolishColor}) -120px -10px`,
                hexaDecimal: 'ffffff'
            },
            {
                id: 2,
                name: 'blue',
                url: `url(${PolishColor}) -10px -80px`,
                hexaDecimal: '007cad'
            },
            {
                id: 3,
                name: 'grey',
                url: `url(${PolishColor}) -10px -150px`,
                hexaDecimal: '848482'
            },
            {
                id: 12,
                name: 'red',
                url: `url(${PolishColor}) -120px -220px`,
                hexaDecimal: 'c10020'
            },
            {
                id: 4,
                name: 'brown',
                url: `url(${PolishColor}) -230px -10px`,
                hexaDecimal: '753313'
            },
            {
                id: 5,
                name: 'black',
                url: `url(${PolishColor}) -230px -80px`,
                hexaDecimal: '000000'
            },
            {
                id: 9,
                name: 'yellow',
                url: `url(${PolishColor}) -120px -150px`,
                hexaDecimal: 'f4c800'
            },
            {
                id: 7,
                name: 'green',
                url: `url(${PolishColor}) -230px -220px`,
                hexaDecimal: '007d34'
            },
            {
                id: 10,
                name: 'orange',
                url: `url(${PolishColor}) -230px -150px`,
                hexaDecimal: 'ff6800'
            },
            {
                id: 6,
                name: 'burgundy',
                url: `url(${PolishColor}) -120px -80px`,
                hexaDecimal: '621c4d'
            },
            {
                id: 11,
                name: 'purple',
                url: `url(${PolishColor}) -340px -10px`,
                hexaDecimal: '943391'
            },
            {
                id: 13,
                name: 'pink',
                url: `url(${PolishColor}) -10px -220px`,
                hexaDecimal: 'ff7e93'
            }
        ]
    },
    [CoatingColor.FABRIC_COLOR]: {
        type: 4,
        items: [
            {
                id: 1,
                name: 'beige',
                url: `url(${FabricColor}) -10px -10px`,
                hexaDecimal: 'e2d6b0'
            },
            {
                id: 2,
                name: 'blue',
                url: `url(${FabricColor}) -10px -80px`,
                hexaDecimal: '007cad'
            },
            {
                id: 3,
                name: 'grey',
                url: `url(${FabricColor}) -10px -150px`,
                hexaDecimal: '848482'
            },
            {
                id: 4,
                name: 'brown',
                url: `url(${FabricColor}) -230px -10px`,
                hexaDecimal: '753313'
            },
            {
                id: 5,
                name: 'black',
                url: `url(${FabricColor}) -230px -80px`,
                hexaDecimal: '000000'
            },
            {
                id: 6,
                name: 'burgundy',
                url: `url(${FabricColor}) -120px -80px`,
                hexaDecimal: '621c4d'
            },
            {
                id: 7,
                name: 'green',
                url: `url(${FabricColor}) -230px -220px`,
                hexaDecimal: '007d34'
            },
            {
                id: 8,
                name: 'white',
                url: `url(${FabricColor}) -120px -10px`,
                hexaDecimal: 'ffffff'
            },
            {
                id: 9,
                name: 'yellow',
                url: `url(${FabricColor}) -120px -150px`,
                hexaDecimal: 'f4c800'
            },
            {
                id: 10,
                name: 'orange',
                url: `url(${FabricColor}) -230px -150px`,
                hexaDecimal: 'ff6800'
            },
            {
                id: 11,
                name: 'purple',
                url: `url(${FabricColor}) -340px -10px`,
                hexaDecimal: '943391'
            },
            {
                id: 12,
                name: 'red',
                url: `url(${FabricColor}) -120px -220px`,
                hexaDecimal: 'c10020'
            },
            {
                id: 13,
                name: 'pink',
                url: `url(${FabricColor}) -10px -220px`,
                hexaDecimal: 'ff7e93'
            }
        ]
    }
}

export default ColorMaterial;

export const Colors = [
    {
        id: 1,
        label: 'beige',
        hexaDecimal: 'e2d6b0'
    },
    {
        id: 2,
        label: 'white',
        hexaDecimal: 'ffffff'
    },
    {
        id: 3,
        label: 'blue',
        hexaDecimal: '007cad'
    },
    {
        id: 4,
        label: 'grey',
        hexaDecimal: '848482'
    },
    {
        id: 5,
        label: 'red',
        hexaDecimal: 'c10020'
    },
    {
        id: 6,
        label: 'brown',
        hexaDecimal: '753313'
    },
    {
        id: 7,
        label: 'black',
        hexaDecimal: '000000'
    },
    {
        id: 8,
        label: 'yellow',
        hexaDecimal: 'f4c800'
    },
    {
        id: 9,
        label: 'green',
        hexaDecimal: '007d34'
    },
    {
        id: 10,
        label: 'orange',
        hexaDecimal: 'ff6800'
    },
    {
        id: 11,
        label: 'purple',
        hexaDecimal: '943391'
    },
    {
        id: 12,
        label: 'burgundy',
        hexaDecimal: '621c4d'
    },
    {
        id: 13,
        label: 'pink',
        hexaDecimal: 'ff7e93'
    }
]
